var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"riseup-header"},[_c('div',{staticClass:"right-nav"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":require('@/assets/riseup-logo.svg')}})])])}
var staticRenderFns = []

export { render, staticRenderFns }